module.exports = __webpack_public_path__ + "img/maria-jasjane.1432cc2b.jpg";